import React from "react";
import SubChapterCard from "../SubChapterCard";
import {getData} from "../../requests/CRUD";
import {sortArray} from "../../utils";
import Icon from "../Icon";
import svgSortAsc from "../../svgs/arrow-up.svg";
import {TRAINING} from "../../consts/tables";
import {videoImage} from "../../consts/consts";

export default class ChapterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chapters: [],
            title: '',
            hasVideo: false,
            videoLink: '',
            backButton: '',
        };
    }

    componentDidMount() {
        this.fetch(this.props.params);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params && Object.keys(this.props.params).length !== Object.keys(nextProps.params).length)
            this.fetch(nextProps.params);
    }

    fetch(params) {
        const keys = Object.keys(params);
        const slugs = params && keys.length ? keys.map(key => params[key]) : [];
        const subchapterParentSlug = slugs.join('/');
        const slug = slugs[slugs.length - 1] || '';
        const parentChapterSlug = slugs[slugs.length - 2] || '';
        slugs.pop();
        const parentSlug = slugs.join('/') || 'training';
        let parentChapterParentSlug = ''
        if (slugs.length) {
            slugs.pop();
            parentChapterParentSlug = slugs.join('/') || 'training';
        }
        const hasVideo = parentSlug === 'brokerage-continuum';

        const requests = [
            getData({
                tableCode: TRAINING,
                options: {
                    column: [
                        'NAME',
                        'VIDEO_LINK',
                    ],
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: parentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }, {
                        text: slug,
                        code: 'SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
            getData({
                tableCode: TRAINING,
                options: {
                    filter: [{
                        text: '',
                        code: 'DELETED',
                        type: 'null',
                    }, {
                        text: subchapterParentSlug,
                        code: 'PARENT_SLUG',
                        type: 'exact',
                    }],
                    filterType: 'and',
                },
            }),
        ];

        if (parentChapterParentSlug)
            requests.push(
                getData({
                    tableCode: TRAINING,
                    options: {
                        column: [
                            'NAME',
                        ],
                        filter: [{
                            text: '',
                            code: 'DELETED',
                            type: 'null',
                        }, {
                            text: parentChapterParentSlug,
                            code: 'PARENT_SLUG',
                            type: 'exact',
                        }, {
                            text: parentChapterSlug,
                            code: 'SLUG',
                            type: 'exact',
                        }],
                        filterType: 'and',
                    },
                })
            )

        Promise.all(requests).then(res => {
            if (res && res[0] && res[0].success && res[1] && res[1].success && (res[2] && res[2].success || !res[2])) {
                const chapters = sortArray(
                    res[1].data.map(chapter => {
                        return {
                            slug: chapter.SLUG,
                            title: chapter.NAME,
                            index: parseInt(chapter.INDEX),
                            img: `${arc.path.media}training/${chapter.PHOTO}`,
                        }
                    }), 'index');

                this.setState({
                    chapters,
                    title: res[0].data[0].NAME || '',
                    hasVideo,
                    videoLink: res[0].data[0].VIDEO_LINK || '',
                    backButton: res[2] ? res[2].data[0].NAME : 'TRAINING',
                });
            }
        });
    }

    render() {
        const {chapters, title, hasVideo, videoLink, backButton} = this.state;

        return (
            <div className='ChapterPage'>
                <div className='page-rounded-corner-container'>
                    <div className='page-header-container'>
                        <div className='page-back-button' onClick={() => {history.back()}}>
                            <Icon svg={svgSortAsc}/>
                            {backButton}
                        </div>
                        <div className='page-header'>
                            <div className='page-title'>{title}</div>
                        </div>
                        <div className='line'/>
                    </div>
                </div>
                <div className='cards-container'>
                    {
                        chapters.map(chapter => (
                            <SubChapterCard
                                key={chapter.slug}
                                img={chapter.img}
                                title={chapter.title}
                                index={chapter.index}
                                link={`${this.props.location.pathname}/${chapter.slug}`}
                            />
                        ))
                    }
                    {
                        hasVideo &&
                        <SubChapterCard
                            key='video'
                            img={arc.path.media + videoImage}
                            title='Video'
                            link={videoLink}
                            newWindow
                        />
                    }
                </div>
            </div>
        )
    }
}